import { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

type MarkdownDescriptionProps = {
  label: string;
};

export const MarkdownDescription = ({ label }: MarkdownDescriptionProps) => (
  <span>
    {label}{' '}
    <Tooltip
      title={
        <div className="description">
          <div>
            <b>You can use: </b>
          </div>
          <div>{`- text => • bullet point`}</div>
        </div>
      }
    >
      <InfoCircleOutlined />
    </Tooltip>
  </span>
);
